export const toNumber = (value: string): number | null => {
  const num = Number(value);
  if (isNaN(num)) return null;
  return num;
};

export const dateToString = (date: Date): string =>
  `${date.getFullYear()}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${date
    .getDate()
    .toString()
    .padStart(2, '0')}`;
